export const formatDate = (dateString: string) => {
	if (dateString) {
		const [month, year] = dateString.split('/');
		const formattedDate = new Date(`${year}-${month}-01`);
		return formattedDate.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
	}
	return 'Date';
};
